import { LoadingButton } from '@mui/lab'
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import { getOhioTitleOwnerNames } from 'controllers/ohioBuildABoxes'
import { OhioBuildABoxBundleDto } from 'dtos/ohioBuildABoxes'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import * as yup from 'yup'

const validationSchema = yup.object({
  ohioTitleOwnerName: yup.string().required('Owner is required.')
})

interface Props {
  initialValues: OhioBuildABoxBundleDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: OhioBuildABoxBundleDto) => void
  open: boolean
}

export default function AddEditBundleDialog({ initialValues, isLoading, onClose, onSave, open }: Props) {
  const [ohioTitleOwnerNames, setOhioTitleOwnerNames] = useState<string[]>([])

  useEffect(() => {
    if (open) getOhioTitleOwnerNames().then(res => setOhioTitleOwnerNames(res.value))
    else setOhioTitleOwnerNames([])
  }, [open])

  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onSave(values)}
        validateOnBlur
        validateOnChange
        validationSchema={validationSchema}
      >
        {({ errors, handleBlur, setFieldValue, values }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <DialogTitle>{initialValues.ohioBuildABoxBundleGuid ? 'Edit' : 'Add'} Bundle</DialogTitle>

                <Grid item xs={12}>
                  <Autocomplete
                    autoHighlight
                    disabled={isLoading}
                    disableListWrap
                    onBlur={handleBlur}
                    onChange={(_e, value) => setFieldValue('ohioTitleOwnerName', value)}
                    options={ohioTitleOwnerNames}
                    renderInput={params => (
                      <TextField {...params} error={Boolean(errors.ohioTitleOwnerName)} helperText={errors.ohioTitleOwnerName} label='Owner' />
                    )}
                    value={values.ohioTitleOwnerName ?? null}
                  />
                </Grid>

                <Grid item xs={12}>
                  <GreenText variant='outlined'>
                    {`**Owner Drop-Down:**

The Owner Drop-Down lists all “Owner Name” fields alphabetically.

These names are sourced from the Vehicle Details > Titles Tab for all vehicles where:

   - Title Application State = Ohio.
   - The vehicle is not associated with any “Build A Box.”
   - The Ready For Build A Box date/time is populated for that vehicle under Ohio Titles.

The owner cannot be changed if there are any vehicles associated with the bundle.

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any changes

**SAVE Button:**

Clicking the SAVE button will save any changes`}
                  </GreenText>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                CANCEL
              </Button>

              <LoadingButton loading={isLoading} type='submit' variant='contained'>
                SAVE
              </LoadingButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
